import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const FeeStructureConfigureLazy = React.lazy(
	() =>
		import(
			/* webpackChunkName : 'FeeStructureConfigure' */ './components/FeeStructureConfigure'
		)
);

export default (store) => {
	return {
		path: 'fee-structure/:campusId?',
		element: <AsyncLoading component={<FeeStructureConfigureLazy />} />,
	};
};
